(function(){
  'use strict';

  function normalise(value){
    return String(value||'')
      .toLowerCase()
      .replace(/matt\b/g,'matte')
      .replace(/[^a-z0-9]+/g,' ')
      .replace(/\s+/g,' ')
      .trim();
  }

  function cleanTextNode(node){
    if(!node) return;
    if(node.nodeType===Node.TEXT_NODE){
      var current=node.nodeValue||'';
      var cleaned=current.replace(/\bA\$/g,'$').replace(/\bAUD\s*/g,'$');
      if(cleaned!==current) node.nodeValue=cleaned;
      return;
    }
    Array.prototype.forEach.call(node.childNodes||[],cleanTextNode);
  }

  function cleanPrices(scope){
    (scope||document).querySelectorAll('.nuvio-variant-collection .nv-vc-price').forEach(cleanTextNode);
  }

  function configureFinishButtons(scope){
    (scope||document).querySelectorAll('.nuvio-variant-collection[data-filter-match-field="variant_title"] .nv-vc-filter').forEach(function(button){
      var labelElement=button.querySelector('.nv-vc-filter-label');
      var label=normalise(labelElement?labelElement.textContent:button.textContent);

      /* Light Brushed Brass is its own separate finish. */
      if(label==='light brushed brass'||label==='light brass'){
        button.setAttribute('data-filter-value','light brushed brass,light brass');
        button.setAttribute('data-nuvio-finish-family','light-brushed-brass');
        return;
      }

      /* Brushed Brass is another name for Brushed Gold. */
      if(label==='brushed gold'||label==='brushed brass'||label==='gold'){
        button.setAttribute('data-filter-value','brushed gold,gold,brushed brass');
        button.setAttribute('data-nuvio-finish-family','brushed-gold');
        if(label==='brushed brass'&&labelElement) labelElement.textContent='Brushed Gold';
      }
    });
  }

  function configure(scope){
    configureFinishButtons(scope);
    cleanPrices(scope);
  }

  function boot(){
    configure(document);
    if(window.MutationObserver&&document.body){
      var queued=false;
      new MutationObserver(function(mutations){
        if(queued) return;
        var relevant=mutations.some(function(mutation){
          var target=mutation.target;
          return target&&target.parentElement&&target.parentElement.closest&&target.parentElement.closest('.nuvio-variant-collection');
        });
        if(!relevant) return;
        queued=true;
        requestAnimationFrame(function(){
          queued=false;
          configure(document);
        });
      }).observe(document.body,{childList:true,subtree:true,characterData:true});
    }
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',function(event){configure(event.target);});
})();
